export default __webpack_public_path__ + "static/media/Exec_time.3e431611.svg";